/** Keys definition for storage data */
export const storageKeys = {
  tokenKey: 'dwbuilder_auth_token',
  userKey: 'dwbuilder_user',
  projectsKey: 'projects_enabled'
};
